"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledField = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _index = require("../index");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var StyledLabel = /*#__PURE__*/(0, _styledComponents["default"])(_index.Label).withConfig({
  displayName: "indexstyles__StyledLabel",
  componentId: "sc-mwo9gq-0"
})(["", ""], function (props) {
  return props.disabled ? (0, _styledComponents.css)(["cursor:auto;color:", ";cursor:not-allowed;"], props.theme.colorTextInputLabelDisabled) : (0, _styledComponents.css)(["cursor:pointer;"]);
});
exports.StyledLabel = StyledLabel;
var StyledField = /*#__PURE__*/(0, _styledComponents["default"])(_index.Fieldset).withConfig({
  displayName: "indexstyles__StyledField",
  componentId: "sc-mwo9gq-1"
})(["", ""], function (props) {
  return props.type === 'date' && !props.value.length && (0, _styledComponents.css)(["::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-year-field{opacity:0.4;}"]);
});
exports.StyledField = StyledField;